/**
 * A set that forgets its oldest keys past `limit` (FE-20: dedupe sets used to
 * grow for the whole session).
 */
export class BoundedKeySet {
  private keys = new Set<string>();

  constructor(private readonly limit: number) {
    if (!(limit > 0)) throw new Error("BoundedKeySet limit must be positive");
  }

  get size() {
    return this.keys.size;
  }

  has(key: string) {
    return this.keys.has(key);
  }

  /** Adds `key`; true when it was not already present. */
  add(key: string) {
    if (this.keys.has(key)) return false;
    this.keys.add(key);
    while (this.keys.size > this.limit) {
      const oldest = this.keys.values().next().value as string;
      this.keys.delete(oldest);
    }
    return true;
  }

  clear() {
    this.keys.clear();
  }
}
